module.exports = __webpack_public_path__ + "img/check.e360e558.svg";